// import React from "react";
// import { useSelector } from "react-redux";
// import { selectClientPermissions } from "../features/auth/authSlice";

// type Permission = "create" | "read" | "update" | "delete";

// interface Props {
//   module: string;
//   action: Permission;
//   children: React.ReactNode;
// }

// const PermissionGuard: React.FC<Props> = ({
//   module,
//   action,
//   children,
// }) => {
//   const permissions = useSelector(selectClientPermissions) || [];

//   const allowed = permissions.some(
//     (p) =>
//       p.module === module &&
//       p.operations.includes(action),
//   );

//   if (!allowed) {
//     return (
//       <div className="p-6 text-center text-gray-500">
//         You don’t have access to this section
//       </div>
//     );
//   }

//   return <>{children}</>;
// };

// export default PermissionGuard;



import React from "react";
import { useSelector } from "react-redux";
import { selectClientPermissions } from "../features/auth/authSlice";
import { useClientPermissions } from "../apis/profileApis";

type Permission = "create" | "read" | "update" | "delete";

interface Props {
  module: string;
  action: Permission;
  children: React.ReactNode;
}

const PermissionGuard: React.FC<Props> = ({ module, action, children }) => {
  const { isLoading } = useClientPermissions();
  const permissions = useSelector(selectClientPermissions);


  if (isLoading || permissions === undefined) {
    return null;
  }

  const allowed = permissions.some(
    (p) => p.module === module && p.operations.includes(action),
  );

  if (!allowed) {
    return (
      <div className="p-6 text-center text-gray-500">
        You don't have access to this section
      </div>
    );
  }

  return <>{children}</>;
};

export default PermissionGuard;